export const MIN_CANDIDATE_SALARY = 0;
export const MAX_CANDIDATE_SALARY_BYN = 100000;
export const MAX_CANDIDATE_SALARY_EUR = 25000;
export const MAX_CANDIDATE_SALARY_PLN = 120000;
export const MAX_CANDIDATE_SALARY_USD = 30000;
